/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_5_TitleInputs */

const da_forside_safe_5_title = /** @type {(inputs: Forside_Safe_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun i EU`)
};

/** @type {(inputs: Forside_Safe_5_TitleInputs) => LocalizedString} */
const en_forside_safe_5_title = da_forside_safe_5_title;

/**

* @param {Forside_Safe_5_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_5_title = /** @type {((inputs?: Forside_Safe_5_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_5_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_5_title(inputs)
	return /** @type {LocalizedString} */ ("Kun i EU")
});